import React, { ComponentPropsWithRef, PropsWithChildren } from "react";

export interface Props
  extends PropsWithChildren<ComponentPropsWithRef<"thead">> {
  children?: React.ReactNode;
}

const TableHeader = (props: Props) => {
  return (
    <thead data-testid="table-head" {...props}>
      {props.children}
    </thead>
  );
};

export default TableHeader;
